import React, { useState, useEffect } from 'react';
import withSizes from 'react-sizes';
import { useFormikContext, Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import { Row, Col, isSizes } from '~layout';
import { H5 } from '~typography';
import { SrLabel, ContentRenderer } from '~helpers';
import { FormButtonGroup, FormRadioButton } from '~form';
import Cell from './Cell';
import ChartDesktopContainer from './ChartDesktopContainer';
import BodyParts from './BodyParts';
import Measure from './Measure';
import Size from './Size';
import Note from './Note';
import SizeGuideHeader from './SizeGuideHeader';
import UnitToggleContainer from './UnitToggleContainer';
import commerceUtils from '../../services/commerceUtils'; // TODO:

var SizeChart = function SizeChart(_ref) {
  var sizeChart = _ref.sizeChart,
      isMobile = _ref.isMobile;

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values;

  var _useState = useState(false),
      checkIsMobile = _useState[0],
      setIsMobile = _useState[1];

  useEffect(function () {
    setIsMobile(isMobile);
  }, [isMobile]);

  var convertUnit = function convertUnit(value, unit) {
    switch (unit) {
      case 'centimeter':
        return value;

      case 'inch':
        return commerceUtils.convertToInches(value);

      default:
        return value;
    }
  };

  var chartBodyParts = sizeChart.map(function (i) {
    return i.bodyParts;
  });
  var chartNotes = Object.values(sizeChart).map(function (i) {
    return i.note;
  }).toString();
  var chartHeaderPart = sizeChart.map(function (i) {
    return i.bodyParts[0];
  });
  var renderSizeListDesktop = chartHeaderPart.map(function (item, index) {
    var partSizes = item.partSizes.map(function (partSize) {
      return Object.values(partSize);
    });
    return /*#__PURE__*/React.createElement(Row, {
      key: index
    }, partSizes.map(function (sizes, sizeIndex) {
      return /*#__PURE__*/React.createElement(Col, {
        key: sizeIndex
      }, /*#__PURE__*/React.createElement(Cell, null, /*#__PURE__*/React.createElement(Size, null, sizes[0])));
    }));
  });
  var renderChartDesktop = chartBodyParts.map(function (item) {
    return item.map(function (i, index) {
      var partSizes = i.partSizes.map(function (partSize) {
        return Object.values(partSize);
      });
      return /*#__PURE__*/React.createElement(Row, {
        alignItems: "center",
        key: index
      }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Cell, {
        isLead: true
      }, /*#__PURE__*/React.createElement(BodyParts, null, i.bodyPart))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, null, partSizes.map(function (sizes, sizeIndex) {
        return /*#__PURE__*/React.createElement(Col, {
          key: sizeIndex
        }, /*#__PURE__*/React.createElement(Cell, null, /*#__PURE__*/React.createElement(SrLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "commerce.chart.size.label",
          values: {
            bodyPart: i.bodyPart,
            size: sizes[0],
            measure: convertUnit(Number(sizes[1]), values.chartUnit),
            unit: values.chartUnit
          }
        })), /*#__PURE__*/React.createElement(Measure, null, convertUnit(Number(sizes[1]), values.chartUnit))));
      }))));
    });
  });
  var renderSizeListMobile = chartHeaderPart.map(function (item, index) {
    var partSizes = item.partSizes.map(function (partSize) {
      return Object.values(partSize);
    });
    return /*#__PURE__*/React.createElement(Row, {
      flexDirection: "column",
      key: index
    }, partSizes.map(function (sizes, sizeIndex) {
      return /*#__PURE__*/React.createElement(Col, {
        key: sizeIndex
      }, /*#__PURE__*/React.createElement(Cell, null, /*#__PURE__*/React.createElement(Size, null, sizes[0])));
    }));
  });
  var renderChartMobile = chartBodyParts.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Row, {
      flexDirection: "row",
      key: index
    }, item.map(function (i, itemIndex) {
      var partSizes = i.partSizes.map(function (partSize) {
        return Object.values(partSize);
      });
      return /*#__PURE__*/React.createElement(Col, {
        key: itemIndex
      }, /*#__PURE__*/React.createElement(Row, {
        flexDirection: "column"
      }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Cell, null, /*#__PURE__*/React.createElement(BodyParts, null, i.bodyPart))), partSizes.map(function (sizes, sizeIndex) {
        return /*#__PURE__*/React.createElement(Col, {
          key: sizeIndex
        }, /*#__PURE__*/React.createElement(Cell, null, /*#__PURE__*/React.createElement(SrLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "commerce.chart.size.label",
          values: {
            bodyPart: i.bodyPart,
            size: sizes[0],
            measure: convertUnit(Number(sizes[1]), values.chartUnit),
            unit: values.chartUnit
          }
        })), /*#__PURE__*/React.createElement(Measure, null, convertUnit(Number(sizes[1]), values.chartUnit))));
      })));
    }));
  });
  var renderUnitToggle = /*#__PURE__*/React.createElement(SizeGuideHeader, null, /*#__PURE__*/React.createElement(H5, {
    color: "muted"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "commerce.chart.sizeGuide.title"
  })), /*#__PURE__*/React.createElement(UnitToggleContainer, null, /*#__PURE__*/React.createElement(Field, {
    component: FormButtonGroup,
    id: "chartUnit",
    title: "Chart unit",
    name: "chartUnit",
    buttonSkin: "info",
    buttonSize: "sm",
    role: "radiogroup"
  }, /*#__PURE__*/React.createElement(Field, {
    component: FormRadioButton,
    id: "chartCm",
    name: "chartUnit",
    value: "centimeter"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "commerce.chart.units.centimeters"
  })), /*#__PURE__*/React.createElement(Field, {
    component: FormRadioButton,
    id: "chartIn",
    name: "chartUnit",
    value: "inch"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "commerce.chart.units.inches"
  })))));
  var renderContent = checkIsMobile ? /*#__PURE__*/React.createElement(React.Fragment, null, renderUnitToggle, /*#__PURE__*/React.createElement(Row, {
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Col, null, renderSizeListMobile), " ", /*#__PURE__*/React.createElement(Col, null, renderChartMobile))) : /*#__PURE__*/React.createElement(ChartDesktopContainer, null, /*#__PURE__*/React.createElement(Row, {
    flexDirection: "column",
    flex: "0 0 auto"
  }, /*#__PURE__*/React.createElement(Col, null, renderUnitToggle), /*#__PURE__*/React.createElement(Col, {
    alignSelf: "flex-end"
  }, renderSizeListDesktop), /*#__PURE__*/React.createElement(Col, null, renderChartDesktop)));
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderContent, /*#__PURE__*/React.createElement(Note, null, /*#__PURE__*/React.createElement(ContentRenderer, {
    source: chartNotes
  })));
};

SizeChart.defaultProps = {
  isMobile: false
};

var mapSizesToProps = function mapSizesToProps(_ref2, _ref3) {
  var width = _ref2.width;
  var theme = _ref3.theme;
  return {
    isMobile: isSizes.xsView({
      width: width
    }, {
      theme: theme
    })
  };
};

export default withSizes(mapSizesToProps)(SizeChart);